import { Wizard } from '../../../../../../domain/wizard/wizard'
import { adminHttpClient } from '../../../../../commons/adminHttpClient'

export const getProductClassDesignWizard = (productClassId: string): Promise<Wizard> => {
  return adminHttpClient.get(`/AdminDashboard/qsehra/ClassDesign/ClassDesignWizard/${productClassId}`)
}
